module.exports = __webpack_public_path__ + "static/media/bottomNewAndroid.f062cc01.png";